import { useIdleTimer } from "react-idle-timer";
import { getStorage } from "../storageHelper";
import { tokenValue } from "../helperConstants";

const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

/**
 * Clears local/session storage and reloads the app once the user has
 * been idle for IDLE_TIMEOUT_MS, but only if a session token is present
 * (no-op for logged-out/pre-auth screens).
 */
export const useIdleLogout = (): void => {
  useIdleTimer({
    timeout: IDLE_TIMEOUT_MS,
    onIdle: () => {
      const token = getStorage(tokenValue);
      if (token) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
      }
    },
  });
};
